import providerProfitFullcont from "./providerProfit-fullcont.html";

const dialog = require("../../../../../components/dialog/dialog");
const fullcontEntity = require("../../../../../components/fullcont/fullcont-entity");
const fullcontHandler = require("../../../../../components/fullcont/fullcont-handler");
const fullcontReport = require("../../../../../components/fullcont/fullcont-report");
const providerProfitDt = require("./providerProfit-dt");
const providerProfitMenu = require("./providerProfit-menu");
const { formCopy } = require("./providerProfit-fullcont-form");
const { form } = require("./providerProfit-fullcont-form");
const MtGenerator = require("./providerProfit-multitable-generator");
const snack = require("../../../../../components/snack/snack");
// const {providerProfitMT} = require('./providerProfit-fullcont-multitable')
const providerProfitMT = undefined; //no MT just add this like undefined
const providerProfitFetch = require("./providerProfit-fetch");
const providerProfit = require("./providerProfit");
const style = require("../../../../../components/report/report-style");
const css = style.get();

let iframe;
let topData = null;
let tableData = null;

/****************ELEMENTS*****************/
var htmlFc = {};
var HTMLwasSelected = false;

function HTMLselect(detail) {
  fullcontHandler.HTMLselect(
    "providerProfit", //database table name****
    "providerProfit", //dest entity on js
    "providerProfit-fullcont",
    providerProfitFullcont,
    form,
    formCopy,
    providerProfitMT,
    editDialog,
    deleteDialog,
    dtCall,
    htmlFc
  );

  HTMLwasSelected = true;
  iframe = document.getElementById("reportIframe");
  // htmlFc.hasFiles = true
  // fullcontHandler.rightsControl(htmlFc)
} /**/

export function start(detail) {
  //console.log('providerProfit-dt 5>', detail)

  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
} /**/

const obj = {
  addOne: {
    start: (detail) => {
      addOne(detail, htmlFc);
    },
  },
  cancelEdit: {
    start: (detail) => {
      fullcontEntity.cancelEdit(detail, htmlFc);
    },
  },
  deleteEntity: {
    start: (detail) => {
      fullcontEntity.deleteEntity(detail, htmlFc);
    },
  },
  deleteFromDialog: {
    start: (detail) => {
      deleteFromDialog(detail, htmlFc);
    },
  },
  discard: {
    start: (detail) => {
      fullcontHandler.discard(detail, htmlFc);
    },
  },
  fullcontOptions: {
    start: (detail) => {
      providerProfitMenu.start(detail, "htmlDt", htmlFc);
    },
  },
  hide: {
    start: (detail) => {
      fullcontEntity.hide(detail, htmlFc);
    },
  },
  prepareAdd: {
    start: (detail) => {
      fullcontEntity.prepareAdd(detail, htmlFc);
    },
  },
  prepareEdit: {
    start: (detail) => {
      fullcontHandler.prepareEdit(detail, htmlFc);
    },
  },
  saveFromDialog: {
    start: (detail) => {
      handler.validate(detail, htmlFc);
    },
  },
  selectOne: {
    start: (detail) => {
      fullcontEntity.selectOne(detail, htmlFc);
    },
  },
  selectOneNoCheck: {
    start: (detail) => {
      fullcontEntity.selectOneNoCheck(detail, htmlFc);
    },
  },
  update: {
    start: (detail) => {
      handler.validate(detail, htmlFc);
    },
  },
  callData: {
    start: (detail) => {
      callData(detail, htmlFc);
    },
  },
  callUnpaidInvoices: {
    start: (detail) => {
      callUnpaidInvoices(detail, htmlFc);
    },
  },
  click: {
    start: (detail) => {
      click(detail, htmlFc);
    },
  },
  printReportAll: {
    start: (detail) => {
      printReportAll(detail, htmlFc);
    },
  },
  printReportOne: {
    start: (detail) => {
      printReportOne(detail, htmlFc);
    },
  },
  purchaseFullcont2: {
    start: (detail) => {
      purchaseFullcont2(detail, htmlFc);
    },
  },
}; /**/

function purchaseFullcont2(detail, htmlFc) {
  providerProfit.start({
    dest: detail.dest,
    elem: "purchaseFullcont2",
    id: "purchase-fullcont3",
    act: "showFullcont",
    dbid: detail.dbid,
  });
}

//function to send
function editDialog() {
  dialog.start({
    act: "show",
    id: "saveChanges",
    entity: "providerProfit",
  });
}

function deleteDialog(detail) {
  dialog.start({
    act: "show",
    dest: "providerProfit",
    id: "deleteElem",
    entity: "providerProfit",
    dbid: detail.dbid,
  });
}

function dtCall(act, result) {
  providerProfitDt.start({ act: act, row: result });
}

function addOne(detail, htmlFc) {
  fullcontEntity.addOne(detail, htmlFc);
  setTimeout(() => {
    // providerProfitDt.start({"dest":"providerProfit", "elem":"dt", "act":"select", "entity":"providerProfit"})
  }, 100);
}

function deleteFromDialog(detail, htmlFc) {
  if (parseInt(htmlFc.fullcontHTML.getAttribute("data-DBid")) > 99) {
    fullcontEntity.deleteFromDialog(detail, htmlFc);
    setTimeout(() => {
      providerProfitDt.start({
        dest: "providerProfit",
        elem: "dt",
        act: "select",
        entity: "providerProfit",
      });
    }, 900);
  } else {
    snack.start({ act: "show", id: "accountidisless" });
  }
}

function callData(detail, htmlFc) {
  const fetchDetail = {
    dest: "provider",
    elem: "report",
    reportType: "accountReceivableAll",
    dbid: detail.dbid,
  };

  providerProfitFetch.fetchOne(fetchDetail, (data) => {
    fullcontReport.showFullcont(detail, data, {
      id: "#providerProfit_form_",
      fields: [
        "provider_name",
        "total_earnings",
        "last_24_hours",
        "last_24_hours_income",
        "last_7_days",
        "last_7_days_income",
        "last_15_days",
        "last_15_days_income",
        "last_30_days",
        "last_30_days_income",
        "last_90_days",
        "last_90_days_income",
        "over_90_days",
        "over_90_days_income",
      ],
    });

    topData = data;
    tryGenerateAndInsert();
  });
}

function callUnpaidInvoices(detail, htmlFc) {
  const container = document.getElementById(
    "multitable-report-provider-profits"
  );

  const fetchDetail = {
    dest: "provider",
    elem: "report",
    reportType: "accountReceivable",
    dbid: detail.dbid,
  };

  providerProfitFetch.fetchUnpaidInvoices(fetchDetail, (data) => {
    fullcontReport.renderProfitInvoices(data, {
      container: container,
      lineRenderer: MtGenerator.unpaid_invoices_list,
      headerHtml: `
        <div class="o54">
          <div class="row">
            <div class="c16"><label class="font-caption label-report">Date</label></div>
            <div class="c16"><label class="font-caption label-report">Code</label></div>
            <div class="c16"><label class="font-caption label-report">Item</label></div>
            <div class="c16"><label class="font-caption label-report">QTY</label></div>
            <div class="c16"><label class="font-caption label-report">Sold QTY</label></div>
            <div class="c16"><label class="font-caption label-report">Profit</label></div>
          </div>
        </div>
      `,
      afterLineRender: (line, item) => {
        fullcontReport.autoAssignValuesByClass(line, item);
      },
    });

    tableData = data;
    tryGenerateAndInsert();
  });
}

function printHtmlInIframe(html) {
  // Si el iframe ya está en about:blank y listo, imprime de inmediato
  const doc = iframe.contentWindow.document;
  if (
    iframe.contentWindow &&
    iframe.contentWindow.location.href === "about:blank"
  ) {
    doc.open();
    doc.write(
      "<!DOCTYPE html><html><head></head><body>" + html + "</body></html>"
    );
    doc.close();
    iframe.contentWindow.print();
    iframe.onload = null;
  } else {
    // Si no, espera a que cargue about:blank
    iframe.onload = function () {
      doc.open();
      doc.write(
        "<!DOCTYPE html><html><head></head><body>" + html + "</body></html>"
      );
      doc.close();
      iframe.contentWindow.print();
      iframe.onload = null;
    };
  }
  iframe.src = "about:blank";
}

function printReportAll(detail, htmlFc) {
  const dataCont = document.querySelector(".providerProfit-dataCont");
  printHtmlInIframe(dataCont.innerHTML);
}

function printReportOne(detail, htmlFc) {
  const dataCont = document.querySelector(".providerProfit-one");
  printHtmlInIframe(dataCont.innerHTML);
}

function tryGenerateAndInsert() {
  if (topData && tableData) {
    const container = document.querySelector(
      "#providerProfit-page-right .dataContReceivable"
    );

    if (!container) {
      console.error("Contenedor no encontrado.");
      return;
    }

    const html = generate(topData, tableData);
    container.innerHTML = ""; // opcional: limpiar antes
    container.insertAdjacentHTML("beforeend", html);

    topData = null;
    tableData = null;
  }
}

function generate(top, table) {
  var body = "";
  body += generateTop(top[0]);
  body += generateTable(table);
  body += `</div> <!-- dataCont -->`;
  body += `<div class="report-page">`;

  return body;
}

function generateTop(data) {
  var table = `
    <div class="dataCont providerProfit-one">
    <div ${css.title}>${data.company_name}</div>
    <div ${css.subtitle}>${data.customer_name} Accounts Profits Per Period As Of ${data.current_dateTime}</div>
  `;

  return table;
} /**/

function generateTable(data) {
  var totals = {
    total_earnings: 0,
  };
  var nextFormat = 0;

  var table = `
    <h2 ${css.f15}>Invoice Breakdown for provider ${data[0].provider_name} - ${data[0].period}: This is a financial document that provides information about money 
      earned to a company by its providers or clients for goods or services provided on credit.</h2>
    <table ${css.table} class="dt-alterColor">
      <tr>
          <th ${css.th}>Invoice Code</th>
          <th ${css.th}>Date</th>
          <th ${css.th}>Item</th>
          <th ${css.th}>QTY</th>
          <th ${css.th}>Sold QTY</th>
          <th ${css.th}>Profits</th>
      </tr> 
  `;

  for (let i = 0; i < data.length; i++) {
    totals.total_earnings += parseFloat(data[i].earnings);

    let detailHtml = `data-detail='{"click": [ {"dest":"ripple" },  
      {"dest":"report", "elem":"fullcont",  "act":"jump", 
      "actJump":"goToPurchase", "dtId":"purchase-dt", "toSearch":"${data[i].code}"  } ] }'`;

    table += `
      <tr ${rowStyle(i)}>
        <td class='tdClick' ${css.td} ${detailHtml} >${data[i].code}</td>
        <td ${css.td}>${data[i].purchase_date}</td>
        <td ${css.td}>${data[i].item_name}</td>
        <td ${css.td}>${data[i].qty}</td>
        <td ${css.td}>${data[i].sold_qty}</td>
        <td ${css.td}>${cashVal(parseFloat(data[i].earnings))}</td>
      </tr> 
    `;
    nextFormat = i + 1;
  }

  //PRINITNG EACH COLUMM TOTAL
  table += `
    <tr ${rowStyle(nextFormat)}>
      <td  ${css.td} style="text-align: right;" colspan="5">
        <div align="right">
          <div style="font-weight: bold;">Total</div>
        </div>
      </td>
      <td ${css.td} >
        <div>${cashVal(totals.total_earnings)}</div>
      </td>
    </tr> 
  `;

  table += `</table>`;

  return table;
}

function cashVal(value) {
  return value.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

function rowStyle(i) {
  if (i % 2 === 0) {
    return "";
  }
  return css.trGray;
}